<script>
import FooterSection from "../package/footerSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import BreadcrumbLogin from "../login/breadcrumbLogin.vue";
import SignInSection from "../login/signInSection.vue";
import AgentSignInSection from "../package/agentSignInSection.vue";
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";
import BreadcrumbResetPassword from "./breadcrumbResetPassword.vue";
import ResetSuccessSection from "./resetSuccessSection.vue";
import DrawerAside from "../package/DrawerAside.vue";

export default {
  name: "passwordResetSuccessfulLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Reset Password Successful";
  },
  created() {
    document.title = "UNIFI Property: Reset Password Successful";
  },
  mounted() {
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    }
  },
  components: {
    ResetSuccessSection,
    BreadcrumbResetPassword,
    AgentSignInSection,
    SignInSection,
    BreadcrumbLogin,
    propertyIconSet,
    FooterSection,
    DrawerAside
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <!--      <drawer-aside :unfold="unfold"/>-->
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <el-header
        style="padding: 0 0 16px 0; height: auto; background-color: #101010"
      >
        <el-row>
          <el-col :span="12" class="left-centered">
            <img
              src="../../assets/logo.png"
              style="width: 101px; height: 41px"
              @click="redirectToHome"
            />
          </el-col>
          <el-col :span="12" class="right-centered">
            <img src="../../assets/menu-alt-1.png" @click="spread" />
          </el-col>
        </el-row>
      </el-header>
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-reset-password />
        <reset-success-section />
        <agent-sign-in-section />
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style lang="scss" scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DiNosaur-a;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
  //background-color: #2D2D2D;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/reset/passwordResetSuccessfulLayout.vue